import { z } from 'zod';

export const showSchema = z.object({
  name: z.string().min(2, 'Naziv mora imati najmanje 2 karaktera'),
  description: z.string().optional(),
  workflowTemplateId: z.string().optional(),
  defaultPriority: z.enum(['NORMAL', 'HIGH', 'URGENT'], {
    message: 'Izaberite prioritet',
  }),
});

export type ShowFormData = z.infer<typeof showSchema>;
